import initialState from '../../Store/initialState';

import { locale } from '../Tools/reducers';
import * as systemTypes from '../System/actionTypes';

const settings = (state = initialState.get('settings'), action) => {
  try {
    switch (action.type) {
      // LOCALE
      case systemTypes.FETCH_USER_LANGUAGE: {
        return state.set('strings', locale(action?.data?.language, 'settings'));
      }

      default:
        return state;
    }
  } catch (e) {
    console.log(e.stack);
    return state;
  }
};
export default settings;
